import React, { Component, Fragment } from "react";
import propTypes from "prop-types";

import TimeItem from "./_formTimeItem";

export default class extends Component {
  static propTypes = {
    times: propTypes.array.isRequired,
    add: propTypes.func.isRequired,
    remove: propTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.timeList = this.makeTimeList();
  }

  makeTimeList() {
    const list = [];

    const dt = new Date();
    const date = new Date().getDate();
    dt.getHM = function() {
      const h = this.getHours();
      const m = this.getMinutes();
      return `${h < 10 ? 0 : ""}${h}:${m < 10 ? 0 : ""}${m}`;
    };
    dt.setHours(9, 0);

    do {
      list.push(dt.getHM());
      dt.setMinutes(dt.getMinutes() + 30);
    } while (date === dt.getDate() || dt.getHM() < "03:30");
    return list;
  }

  render() {
    const { times, add: addAction, remove: removeAction } = this.props;
    return (
      <Fragment>
        <div className="office-add-session__time-list">
          <div style={{ display: "contents" }}>
            <div className="office-add-session__time-header">Время начала</div>
            {(times || []).sort().map((time, index) => (
              <div
                key={index}
                onClick={() => removeAction(time)}
                className="office-add-session__time-item office-add-session__time-item_selected"
              >
                {time}
              </div>
            ))}
          </div>
        </div>
        <hr />
        <div className="office-add-session__time-list">
          {this.timeList.map((time, index) => (
            <div
              key={index}
              // onClick={() => addAction(time)}
              className="office-add-session__time-item"
            >
              <TimeItem time={time} addAction={addAction} />
            </div>
          ))}
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/schedule/_formTime.jsx